import { Component, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-custom-vendor-reporting-instructions',
    templateUrl: './custom-vendor-reporting-instructions.component.html',
    styleUrls: ['./custom-vendor-reporting-instructions.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CustomVendorReportingInstructionsComponent {

  constructor(public modal: NgbActiveModal) { }

}
